var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.7 324.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#ccc;}.cls-3{fill:#1b1464;}.cls-4{fill:#fff;}.cls-5{fill:#42210b;}.cls-6,.cls-8{fill:#006837;}.cls-6{opacity:0.2;}.cls-7{fill:#cee2f2;opacity:0.02;}.cls-9{fill:#333;}.cls-10{fill:#34495e;}.cls-11{fill:#009245;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 12ok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.43,143.49C100.06,123.07,45.54,136.55,0,157.22V307.66a17.2,17.2,0,0,0,17.2,17.2H349.79C308,253.37,228.75,179.74,146.43,143.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.17,260.3C178.09,188.65,101,296.75,101,296.75S82.06,187.24,0,113.86V303.24c0,11.94,11.2,21.62,25,21.62H390.36C394.37,303.49,381,281.19,335.17,260.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.43,294.49s-74,30-169-12-143-49-185-26c-23,12.6-38.51,4.19-52.43-13.22v64.39a17.2,17.2,0,0,0,17.2,17.2H495.7C461.42,289.44,406.43,294.49,406.43,294.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166,54.7V177.29a9.57,9.57,0,0,1-9.56,9.57H57.55A9.57,9.57,0,0,1,48,177.29V28.43a9.56,9.56,0,0,1,9.57-9.57H130.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.05,54.68l-25.66,0a9.56,9.56,0,0,1-9.58-9.56l0-26.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 57.06,
    y: 73.34,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.95,
    y: 73.34,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 57.06,
    y: 91.51,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.95,
    y: 91.51,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 57.06,
    y: 109.67,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.95,
    y: 109.67,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 57.06,
    y: 127.83,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.95,
    y: 127.83,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 57.06,
    y: 145.99,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.95,
    y: 145.99,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 57.06,
    y: 164.15,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.95,
    y: 164.15,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 85.58,
    y: 88.86,
    width: 114.46,
    height: 110.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "163.41 109.43 142.81 89.5 122.2 109.43 125.87 112.53 140.52 98.36 140.52 147.08 145.1 147.08 145.1 98.36 159.75 112.53 163.41 109.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M177.14,117.65H149.67v4.42H174.4l20.14,31H163.41v8.85a9,9,0,0,1-9.16,8.86H131.36a9,9,0,0,1-9.16-8.86v-8.85H91.07l20.15-31h24.72v-4.42H108.47L85.58,153.08v39.86H200V153.08Zm18.32,70.86H90.16v-31h27.47v6.64a11.15,11.15,0,0,0,11.44,11.07h27.47A11.16,11.16,0,0,0,168,164.15v-6.64h27.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90.16,157.51v31h105.3v-31H168v6.64a11.16,11.16,0,0,1-11.45,11.07H129.07a11.15,11.15,0,0,1-11.44-11.07v-6.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "19.65 72.01 38.86 46.23 54.45 79.76 117.84 0 129.53 19 140.6 37 49.91 97.91 19.65 72.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "53.69 87.18 132.55 23.91 140.6 37 49.91 97.91 19.65 72.01 29.66 58.58 53.69 87.18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/BG_3.fb58124fa4e87174a8b6df29b305e5d1.svg";
export { ForwardRef as ReactComponent };